import React from "react";
import "./ManualAddressForm.css";

const ManualAddressForm = ({ 
  formData, 
  onChange, 
  required = false, 
  onBlur = null,
  error = "",
  name = "address"
}) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange(name, value); // Call the parent's onChange handler
  };

  return (
    <div className="manualAddressForm">
      <div className="formGroup">
        <label>
          Address Line 1 {required && <span className="required-mark">*</span>}
        </label>
        <input
          type="text"
          name="addressLine1"
          placeholder="Address Line 1"
          className={`input ${error && !formData.addressLine1 ? 'input-error' : ''}`}
          required={required}
          value={formData.addressLine1 || ""}
          onChange={handleInputChange}
          onBlur={onBlur}
          data-testid={`${name}-addressLine1`}
        />
      </div>
      <div className="formGroup">
        <label>Address Line 2</label>
        <input
          type="text"
          name="addressLine2"
          placeholder="Address Line 2"
          className="input"
          value={formData.addressLine2 || ""}
          onChange={handleInputChange}
          data-testid={`${name}-addressLine2`}
        />
      </div>
      <div className="row">
        <div className="formGroup">
          <label>
            City {required && <span className="required-mark">*</span>}
          </label>
          <input
            type="text"
            name="city"
            placeholder="City"
            className={`input ${error && !formData.city ? 'input-error' : ''}`}
            required={required}
            value={formData.city || ""}
            onChange={handleInputChange}
            onBlur={onBlur}
            data-testid={`${name}-city`}
          />
        </div>
        <div className="formGroup">
          <label>
            State {required && <span className="required-mark">*</span>}
          </label>
          <input
            type="text"
            name="state"
            placeholder="State"
            className={`input ${error && !formData.state ? 'input-error' : ''}`}
            required={required}
            value={formData.state || ""}
            onChange={handleInputChange}
            onBlur={onBlur}
            data-testid={`${name}-state`}
          />
        </div>
      </div>
      <div className="formGroup">
        <label>
          Pin Code {required && <span className="required-mark">*</span>}
        </label>
        <input
          type="text"
          name="pincode"
          placeholder="Pin Code"
          className={`input ${error && !formData.pincode ? 'input-error' : ''}`}
          required={required}
          value={formData.pincode || ""}
          onChange={handleInputChange}
          onBlur={onBlur}
          data-testid={`${name}-pincode`}
        />
      </div>
    </div>
  );
};

export default ManualAddressForm;
